import React from 'react'

import { useAppSelector } from '@app/app.hook'
import { selectStrings } from '@app/slices/slice.app'

import { IDS } from '@fmt/constants'
import { DepartmentKeys, DepartmentValues } from '@fmt/type'
import { FormikProps } from 'formik'

interface ComponentProps {
    readOnly: boolean
    departmentEditFormik: FormikProps<DepartmentValues>
    handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>,
        fieldName?: DepartmentKeys) => void
}

const StreetName = ({ readOnly, departmentEditFormik, handleKeyDown }:ComponentProps) => {
    const strings = useAppSelector(selectStrings)
    const fieldName: DepartmentKeys = 'departmentAddressStreet'

    const result = <div className={'form-group'}>
        <div className={'row mt-3 align-items-center'}>
            <div className={'col-3 d-none d-sm-block'}>
                <label htmlFor={IDS.DEPARTMENT.EDIT.STREET} className={'form-label'}>{
                    strings.fmt?.text.facility.add.steps['1'].street_name
                }</label>
            </div>
            <div className={'col-sm-9 col-12'}>
                <input
                    readOnly={readOnly}
                    type={'text'}
                    name={fieldName}
                    className={[
                        'form-control-sm',
                        readOnly ? 'form-control-plaintext' : 'form-control',
                        departmentEditFormik.errors.departmentAddressStreet && 'border-danger'
                    ].join(' ')}
                    placeholder={!readOnly
                        ? strings.fmt?.text.facility.add.steps['1'].street_name
                        : ''}
                    value={departmentEditFormik.values.departmentAddressStreet}
                    id={IDS.DEPARTMENT.EDIT.STREET}
                    onBlur={departmentEditFormik.handleBlur}
                    onChange={!readOnly ? departmentEditFormik.handleChange : () => {}}
                    onKeyDown={handleKeyDown}
                    required
                />
                <div className={'form-text error'}>{
                    departmentEditFormik.errors.departmentAddressStreet
                        ? departmentEditFormik.errors.departmentAddressStreet
                        : null
                }</div>
            </div>

        </div>

    </div>

    return result
}

export default StreetName
